import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import pointerIcon from '@/assets/images/icons/pointer.svg';
import editIcon from '@/assets/images/icons/edit.svg';

import validationFlow from '@/validation-flow';

export default {
  name: 'ServiceCenterItem',
  components: {
    pointerIcon,
    editIcon,
  },
  props: {
    depot: null,
    disableServiceCenterPicker: false,
    selected: false,
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      slotNumber: 'getSlotNumber',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setDepotMutation: 'SET_DEPOT',
    }),
    ...mapActions('appointment', {
      clearSlotNumber: 'CLEAR_SLOTNUMBER',
    }),
    setServiceCenter() {
      this.setDepotMutation(this.depot.depotId);
      if (this.slotNumber !== '' && this.selected === false) {
        this.clearSlotNumber(this.slotNumber);
      }

      this.$emit('on-set-service-center');
      validationFlow.checkIfRedirectToPos(this.depot.depotId);
    },
  },
};
